(() => {
    if (document.getElementById('categoryPast')) {
        const button = document.getElementById('categoryPast-button');
        const panel = document.getElementById('categoryPast');

        button.addEventListener('click', () => {
            button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        });

        document.addEventListener('click', (e) => {
            if (!button.contains(e.target) && !panel.contains(e.target)) {
                button.setAttribute('aria-expanded', 'false');
            }
        });
    }
})();
